import React from 'react'
import { connect } from 'react-redux'
import { Row, Col, Steps, Input, Button, Icon } from 'antd'

import './index.css'

import UndrawApplication from 'assets/images/onboarding/messaging-application.svg'
import UndrawChannels from 'assets/images/onboarding/channels.svg'
import UndrawBuilding from 'assets/images/onboarding/building.svg'
import UndrawCelebration from 'assets/images/onboarding/celebration.svg'

import RightContent from 'components/OnboardingNow/RightContent'

import StepOne from 'components/OnboardingNow/StepOne'
import StepTwo from 'components/OnboardingNow/StepTwo'
import StepThree from 'components/OnboardingNow/StepThree'
import EndHtml from 'components/OnboardingNow/EndHtml'
import EndWordPress from 'components/OnboardingNow/EndWordPress'
import End from 'components/OnboardingNow/End'

import {
    SETUP_PROJECT,
    SETUP_CHANNELS,
    CHOOSE_PLUGIN,
    PLUGIN_CUSTOM,
    PLUGIN_WORDPRESS,
    CONGRATGS
} from 'redux/OnBoardingNow/steps'

const { Step } = Steps

class OnBoarding extends React.Component {
    render() {
        const { currentState } = this.props

        return (
            <Row style={{ height: '100%', margin: 0 }}>
                <Col xs={24} lg={12} style={{ backgroundColor: 'white' }}>
                    <div className="form-layout">
                        <div style={{ flex: 2 }}></div>
                        <div style={{ flex: 7 }}>
                            <Row type="flex" justify="center" style={{ width: '100%' }}>
                                {(function() {
                                    switch (currentState) {
                                        case SETUP_PROJECT:
                                            return <StepOne />
                                        case SETUP_CHANNELS:
                                            return <StepTwo />
                                        case CHOOSE_PLUGIN:
                                            return <StepThree />
                                        case PLUGIN_CUSTOM:
                                            return <EndHtml />
                                        case PLUGIN_WORDPRESS:
                                            return <EndWordPress />
                                        case CONGRATGS:
                                            return <End />
                                    }
                                })()}
                            </Row>
                        </div>
                        <div style={{ flex: 1 }} />
                        <div style={{ flex: 1 }}>
                            <Row type="flex" justify="center" style={{ width: '100%' }}>
                                <Col span={22}>
                                    <Steps
                                        current={
                                            currentState == SETUP_PROJECT || currentState == SETUP_CHANNELS ? 1 : 2
                                        }
                                    >
                                        <Step title="Finished" description="Create an account." />
                                        <Step
                                            title={
                                                currentState == SETUP_PROJECT || currentState == SETUP_CHANNELS
                                                    ? 'In Progress'
                                                    : 'Finished'
                                            }
                                            description="Setup your project."
                                        />
                                        <Step
                                            title={
                                                currentState == SETUP_PROJECT || currentState == SETUP_CHANNELS
                                                    ? 'Waiting'
                                                    : currentState == CONGRATGS
                                                    ? 'Finished'
                                                    : 'In Progress'
                                            }
                                            description="Install Ekko."
                                        />
                                    </Steps>
                                </Col>
                            </Row>
                        </div>
                        <div style={{ flex: 1 }} />
                    </div>
                </Col>
                <Col xs={0} lg={12}>
                    {(function() {
                        switch (currentState) {
                            case SETUP_PROJECT:
                                return (
                                    <RightContent
                                        image={UndrawApplication}
                                        title="Ready to embed Ekko on your application ?"
                                    />
                                )
                            case SETUP_CHANNELS:
                                return (
                                    <RightContent
                                        image={UndrawChannels}
                                        title="Topics are places where your users can discuss"
                                    />
                                )
                            case CHOOSE_PLUGIN:
                            case PLUGIN_CUSTOM:
                            case PLUGIN_WORDPRESS:
                                return <RightContent image={UndrawBuilding} title="One last step before using Ekko" />
                            case CONGRATGS:
                                return (
                                    <RightContent image={UndrawCelebration} title="Congrats! You can now use Ekko!" />
                                )
                        }
                    })()}
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = ({ onboarding }) => ({
    currentState: onboarding.currentState
})

const mapActionsToProps = dispatch => ({})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(OnBoarding)
